import React, { forwardRef, useImperativeHandle, useRef, useState } from 'react';
import ErrorBoundary from 'src/components/10-atoms/ErrorBoundary';
import WidgetErrorFallback from 'src/components/10-atoms/ErrorBoundary/WidgetErrorFallback';
import Column from 'src/components/10-atoms/layout/Column';
import { bottomDrawerHelperActions } from 'src/components/20-helper-views/bottom-drawer/useBottomDrawer';
import useFTUE from 'src/lib/ftue/hooks/useFTUE';
import FTUEKeys from 'src/lib/ftue/keys';
import QuillEditor from '../QuillEditor';
import isEmpty from '../QuillEditor/utils/isEmpty';
import Toolbar from '../Toolbar';
import useChangeHandler from './handlers/useChangeHandler';
import useFocusHandler from './handlers/useFocusHandler';
import Img2TxtIntroDrawer from './Img2TxtIntroDrawer';
const HTMLEditor = forwardRef(({ initialValue, initialDelta, placeholder, gutterBottom, onChange, onFocus, onBlur, ...columnProps }, ref) => {
    const [quillRef, setQuillRef] = useState();
    const quillEditorInnerRef = useRef(null);
    useFocusHandler(quillRef, {
        onBlur,
        onFocus,
    });
    useChangeHandler(quillRef, { onChange });
    useImperativeHandle(ref, () => ({
        getContents: () => quillRef?.getContents(),
        getHTML: () => quillRef?.getSemanticHTML(),
        getText: () => quillRef?.getText(),
        hasContent: () => (quillRef ? !isEmpty(quillRef) : false),
        setHTML: (html) => quillEditorInnerRef.current?.setHTML(html),
    }), [quillRef]);
    useFTUE(FTUEKeys.IMG2TXT_INTRODUCTION, {
        onFTUE(markComplete) {
            bottomDrawerHelperActions.show({
                component: React.createElement(Img2TxtIntroDrawer, { onConfirm: () => {
                        bottomDrawerHelperActions.hide();
                        markComplete();
                    } }),
            });
        },
    });
    return (React.createElement(ErrorBoundary, { renderError: () => (React.createElement(WidgetErrorFallback, { message: "Unable to load the editor", ...columnProps })) },
        React.createElement(Column, { ...columnProps },
            React.createElement(QuillEditor, { ref: quillEditorInnerRef, onEditorChanged: setQuillRef, readOnly: false, enableCachedImage: false, initialValue: initialValue, initialDelta: initialDelta, placeholder: placeholder, flex: true, gutterBottom: gutterBottom }),
            React.createElement(Toolbar, { quill: quillRef }))));
});
export default HTMLEditor;
